import React from "react";
import "./navbar.css";
import { Nav, NavbarContainer, NavLogo } from "./NavbarElements";

const Navbar = () => {
  return (
    <>
      <Nav>
        <NavbarContainer>
          <NavLogo to="/">Tweencraft</NavLogo>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
